import React from "react";
import style from "./CircularProgress.scss";

export const CircularProgress = ({ sm = false }) => (
  <div className={`${style.loader} ${sm ? style.sm : ""}`} />
);
